import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Input, Table } from "reactstrap";
import Pagination from "react-js-pagination";
import Footer from "../../../../../GlobalComponents/Footer";
import Navbar from "../../../Navbar";
import DashboardSidebar from "../../NewDashboardSidebar";
import { returnBookingService } from "../../../../../../services/returnBooking.services";
import useDebounce from "../../../../../../helpers/UseDebounce";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import { formatDate } from "../../../../../../helpers/dateHelper";
import moment from "moment";
import Norecord from "./Norecord.js";
import { exportXls } from "../Common/ExportXls";
import Return from "../Common/Return";
import ReturnDetails from "../Common/ReturnDetails";
import PrepareModal from "../Model/PrepareModel";
import PrepareTimer from "../Common/PrepareTimer";
import ReturnForInvoiceModal from "../Model/ReturnForInvoiceModel.js";
import { getStatusConfig } from "../../../../../../helpers/statusHelper";

let newDate = new Date();
let date = newDate.getDate();
let month = newDate.getMonth() + 1;
let year = newDate.getFullYear();
let separator = "-";
const todayDate = `${year}${separator}${month < 10 ? `0${month}` : `${month}`
    }${separator}${date < 10 ? `0${date}` : `${date}`}`;
let yesterday = moment(todayDate).subtract(1, "days").format("YYYY-MM-DD");
let lastYear = moment(todayDate).subtract(360, "days").format("YYYY-MM-DD");

const Index = () => {

    const [search, setSearch] = useState("");
    const [activePage, setActivePage] = useState(1);
    const [totalItemsCount, setTotalItemsCount] = useState("");
    const [loading, setLoading] = useState(false);
    const [bookingList, setBookingList] = useState([]);
    const [user, setUser] = useState(JSON.parse(localStorage.getItem("user")));
    const [firstLoad, setFirstLoad] = useState(0);
    const [bookingId, setBookingId] = useState(0);
    const [returnModal, setReturnModal] = useState(false);
    const [detailsModal, setDetailsModal] = useState(false);
    const [detailsModalResult, setDetailsModalResult] = useState([]);
    const [prepareModal, setPrepareModal] = useState(false);
    const [returnForInvoiceModal, setReturnForInvoiceModal] = useState(false);
    const [prepareBookingStatus, setPrepareBookingStatus] = useState("");

    const handleSearch = (val) => {
        setSearch(val);
        setActivePage(1);
    };

    const handlePageChange = (pageNumber) => {
        setActivePage(pageNumber);
        if (pageNumber !== activePage) {
            setLoading(true);
            window.scrollTo({ top: 0 });
        }
    };

    const getList = async () => {
        setBookingList([]);
        setLoading(true);
        setFirstLoad(1);
        try {

            const res = await returnBookingService.getUnprocessedList({
                bookedByFilter: "",
                hospitalFilter: "",
                type: ["loan"],
                status: ["dispatch", "close","return","prepare","query"],
                returnDateFiter: lastYear,
                toReturnDateFiter: yesterday,
                search: search,
                page: activePage,
                limit: 50,
                isReturned: true
            });
            setBookingList(res.data);
            setTotalItemsCount(res.total_count);
            setLoading(false);
        } catch (error) {
            console.error("Error: ", error);
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };


    const getXlsxData = async () => {
        setLoading(true);
        try {
            const res = await returnBookingService.getUnprocessedExport({
                bookedByFilter: "",
                hospitalFilter: "",
                type: ["loan"],
                status: ["dispatch", "close","return","prepare","query"],
                returnDateFiter: lastYear,
                toReturnDateFiter: yesterday,
                search: search,
                page: activePage,
                limit: 50,
                isReturned: true
            });
            if (res.status === 200) {
                let dateInfo = "";
                dateInfo = "from " + moment(lastYear).format("DD/MM/YYYY") + " to " + moment(yesterday).format("DD/MM/YYYY") + " ";
                let headingContent = "Return past " + dateInfo;
                exportXls.handleExportClick(res?.data, headingContent);
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };


    const detailsModalOpen = (item) => {
        setDetailsModal(true);
        setDetailsModalResult(item);
    };

    const detailsModalClose = () => {
        setDetailsModal(false);
    };


    const prepareModalOpen = (item) => {
		setPrepareModal(true);
		setBookingId(item._id);
       
        setPrepareBookingStatus(item.status);
	};

    const prepareModalClose = (flag) => {
		setPrepareModal(false);
		setBookingId(0);
		setActivePage(1);
        setPrepareBookingStatus("");
		if (activePage == 1 && flag) {
			getList();
		}
	};

    const returnForInvoiceModalOpen = (id) => {
		setReturnForInvoiceModal(true);
		setBookingId(id);
	};

    const returnForInvoiceModalClose = (flag) => {
		setReturnForInvoiceModal(false);
		setBookingId(0);
		setActivePage(1);
		if (activePage == 1 && flag) {
			getList();
		}
	};


    const returnModalOpen = (id) => {
        setReturnModal(true);
        setBookingId(id);
    };

    const returnModalClose = () => {
        setReturnModal(false);
        setBookingId(0);
    };
    const returnSuccess = () => {
        setReturnModal(false);
        setBookingId(0);
        setActivePage(1);
        if (activePage == 1) {
            getList();
        }
    };


    useDebounce(() => {
        if (firstLoad != 0)
            getList();
    }, [search], 800
    );

    useEffect(() => {
        getList();
    }, [activePage]);


    useEffect(() => {
        setUser(JSON.parse(localStorage.getItem("user")));

    }, []);



    if (!user || user.data.user_role !== "admin") {
        return <Redirect to="/" />;
    }



    return (
        <div>
            <Navbar activePage="dashboard" />
            <main className="offset">
                <div className="container-fluid">
                    <div className="row pt-4">
                        <div className="col-lg-2 side-filters">
                            <span className="side-heading">Dashboard</span>
                            <DashboardSidebar
                                activePage="u-return"
                                unprocessedReturnCounts={totalItemsCount}
                            />
                        </div>
                        <div className="col-lg-10">
                            <div className="ground">
                                <div className="row">
                                    <div className="col-lg-4 col-md-12 mb-2">
                                        <div className="sub-menu mb-0 mb-sm-3">


                                        </div>

                                    </div>

                                    <div className="col-lg-4 col-sm-6 mb-2">
                                        <div className="form-search">
                                            <Input
                                                className="form-control mr-sm-2"
                                                type="text"
                                                placeholder="Search.."
                                                value={search}
                                                onChange={e =>
                                                    handleSearch(
                                                        e.target.value,
                                                    )
                                                }
                                            />
                                        </div>

                                    </div>

                                    <div className="col-lg-4 col-sm-6 mb-2">
                                        <div style={{ float: "right" }}>

                                            <button type="button" className={!loading ? "btn btn-default add_option" : "btn btn-default add_option dropdown-disabled"}
                                                onClick={() => !loading && bookingList?.length ? getXlsxData() : ""}> Print </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="table-scroll mt-4">
                                    <Table className="table">
                                        <thead>
                                            <tr>
                                                <th
                                                    scope="col"
                                                    style={{
                                                        minWidth: "200px",
                                                    }}>
                                                    Booking #
                                                </th>
                                                <th scope="col">
                                                    Hospital Name{" "}
                                                </th>
                                                <th scope="col">Set</th>
                                                <th scope="col">Date</th>
                                                <th scope="col">
                                                    Dispatched Boxes
                                                </th>
                                                <th scope="col">Time Taken</th>
                                                <th scope="col">Status</th>

                                                <th
                                                    scope="col"
                                                    className="text-right"></th>
                                            </tr>
                                        </thead>
                                        <tbody key={"tbody"}>
                                            {bookingList &&
                                                bookingList.map(item => (
                                                    <tr key={item._id}>
                                                        <td
                                                            width="200"
                                                            data-th="Booking #"
                                                            className="align-top">
                                                            <Link
                                                                to={
                                                                    "/admin/booking/details/" +
                                                                    item._id
                                                                }>
                                                                <span>
                                                                    <strong>
                                                                        {" "}
                                                                        {
                                                                            item.booking_id
                                                                        }{" "}
                                                                    </strong>
                                                                </span>
                                                            </Link>
                                                        </td>
                                                        <td
                                                            data-th="Hospital Name"
                                                            className="align-top">
                                                            <div className="">
                                                                {
                                                                    item
                                                                        .hospitalId
                                                                        .name
                                                                }
                                                            </div>
                                                        </td>
                                                        <td
                                                            data-th="Set"
                                                            className="align-top">
                                                            <ul className="list">
                                                                {item.bookingKitSetId &&
                                                                    item.bookingKitSetId.map(
                                                                        (
                                                                            kset,
                                                                            ind,
                                                                        ) => (
                                                                            <React.Fragment
                                                                                key={
                                                                                    ind
                                                                                }>
                                                                                    {(() => {
                                                                                    let newstatus = kset.status;

                                                                                    if (kset?.status=="booked" && kset?.draft_set_free === "true") {
                                                                                        newstatus = "free_set";
                                                                                    } else if (kset?.status=="booked" && kset?.draft_check_set === "true") {
                                                                                        newstatus = "return";
                                                                                    }

                                                                                    return (
                                                                                        <li>
                                                                                        <span
                                                                                            className={`status circle mr-1 ${getStatusConfig(newstatus).circalClassName}`}
                                                                                            data-toggle="tooltip"
                                                                                            data-placement="top"
                                                                                            data-original-title="Returned"
                                                                                        ></span>
                                                                                        <span className={`cross-line-${newstatus}`}>
                                                                                            {kset?.setId[0]?.set_name} 
                                                                                        </span>
                                                                                        </li>
                                                                                    );
                                                                                    })()}
                                                                                
                                                                            </React.Fragment>
                                                                        ),
                                                                    )}
                                                            </ul>
                                                        </td>
                                                        <td className="align-top">
                                                            {
                                                                item?.next_return_date ?
                                                                formatDate(item.next_return_date)
                                                                    :
                                                                    ""
                                                            }
                                                        </td>
                                                        <td
                                                            data-th="Dispatched Boxes"
                                                            className="align-top">
                                                            {item?.bookingdispatches &&
                                                                item?.bookingdispatches[0]?.bookingdispatchboxes.map(
                                                                    (
                                                                        box,
                                                                        ind,
                                                                    ) => (
                                                                        <React.Fragment
                                                                            key={
                                                                                ind
                                                                            }>
                                                                            <div>
                                                                                {
                                                                                    box.box_type
                                                                                }{" "}
                                                                                -{" "}
                                                                                {
                                                                                    box.number_of_box
                                                                                }{" "}
                                                                                {box.number_of_box >
                                                                                    1
                                                                                    ? "Boxes"
                                                                                    : "Box"}
                                                                            </div>
                                                                        </React.Fragment>
                                                                    ),
                                                                )}
                                                        </td>

                                                        <td className="align-top">
                                                            <PrepareTimer item={item} />
                                                        </td>
                                                         <td className="align-top">
                                                                {(item.status == "prepare"  || item.status == "query" || item.status == "return" || item.status == "close") && 
                                                                    
                                                                    <span
                                                                    className={`mr-2 capsule ${getStatusConfig(item.status).className}`}
                                                                    >
                                                                    {getStatusConfig(item.status).label}
                                                                    </span>
                                                                }
                                                            </td>
                                                        <td className="align-top">
                                                           <React.Fragment>
                                                                <div >
                                                                    {item.status == "dispatch" &&

                                                                        <a
                                                                            href="javascript:;"
                                                                            onClick={() =>
                                                                                returnModalOpen(
                                                                                    item._id,
                                                                                )
                                                                            }
                                                                            className="btn btn-primary ml-2">
                                                                            Return
                                                                        </a>
                                                                        }
                                                                        {item.status == "return" &&
                                                                        <a
                                                                            href="javascript:;"
                                                                            onClick={() =>
                                                                                prepareModalOpen(
                                                                                    item
                                                                                )
                                                                            }
                                                                            className="btn btn-primary ml-2">
                                                                            Prepare Return
                                                                        </a>
                                                                        }
                                                                        {item.status == "prepare" &&
                                                                        <a
                                                                            href="javascript:;"
                                                                            onClick={() =>
                                                                                returnForInvoiceModalOpen(
                                                                                    item._id,
                                                                                )
                                                                            }
                                                                            className="btn btn-primary ml-2">
                                                                            Send for Invoicing
                                                                        </a>
                                                                        }
                                                                        
                                                                    {item.bookingreturns.length ? (
                                                                        <div> <a
                                                                            href="javascript:;"
                                                                            onClick={() =>
                                                                                detailsModalOpen(
                                                                                    item.bookingreturns
                                                                                )
                                                                            }
                                                                            className="btn ml-2">
                                                                            Details
                                                                        </a> </div>
                                                                    )
                                                                        : <a className="btn text-right" style={{ visibility: "hidden" }}>Details</a>}
                                                                </div>

                                                            </React.Fragment>
                                                                                                                           
                                                        </td>
                                                    </tr>
                                                ))}

                                            {loading == true &&
                                                <Norecord />

                                            }

                                            {bookingList &&
                                                bookingList.length == 0 && firstLoad != 0 &&
                                                loading == false && (
                                                    <tr className="text-center">
                                                        <td colSpan="7">
                                                            No Record Found
                                                        </td>
                                                    </tr>
                                                )}
                                        </tbody>
                                    </Table>
                                </div>
                            </div>

                            {bookingList && bookingList.length > 0 && (
                                <div>
                                    <Pagination
                                        activePage={activePage}
                                        itemsCountPerPage={50}
                                        totalItemsCount={
                                            totalItemsCount
                                        }
                                        pageRangeDisplayed={5}
                                        onChange={handlePageChange.bind(
                                            this,
                                        )}
                                        itemClass="page-item"
                                        linkClass="page-link"
                                        innerClass="pagination justify-content-center mb-5"
                                        activeLinkClass="active"
                                        nextPageText="Next"
                                        prevPageText="Prev"
                                    />
                                    <br className="d-block d-sm-none" /><br className="d-block d-sm-none" />
                                </div>
                            )}

                        </div>
                    </div>
                    {/*<!--/row-->*/}
                </div>
            </main>

            <ReturnDetails
                bookingId={bookingId}
                detailsModal={detailsModal}
                detailsModalResult={detailsModalResult}
                detailsModalClose={() =>
                    detailsModalClose()
                }
            />

            <Return
                bookingId={bookingId}
                returnModal={returnModal}
                returnModalOpen={
                    returnModalOpen
                }
                returnModalClose={
                    returnModalClose
                }
                returnSuccess={returnSuccess}
            />


           <PrepareModal
                bookingId={bookingId}
                prepareModal={prepareModal}
                status={prepareBookingStatus}
                prepareModalClose={(flag) =>
                    prepareModalClose(flag)
                }
            />

            <ReturnForInvoiceModal
                bookingId={bookingId}
                returnForInvoiceModal={returnForInvoiceModal}
                returnForInvoiceModalClose={(flag) =>
                    returnForInvoiceModalClose(flag)
                }
            />

            <Footer />
        </div>
    );
};
export default Index;

